<template>
    <q-page class="docs-table" :style-fn="myTweak">
        <q-table
            grid
            :data="limits"
            ref="rampUserTable"
            row-key="id"
            hide-header
            hide-bottom
            @request="all"
        >
            <template v-slot:item="props">
                <div class="q-pa-sm col-xs-12 col-sm-6 col-md-4 col-lg-4 grid-style-transition">
                    <transfer-limit-card
                        v-model="props"
                        :user-id="user.id"
                        @attach="makeTransferLimit"
                        @detach="deleteTransferLimit"
                    />
                </div>
            </template>
        </q-table>
        <q-inner-loading
            :showing="loading"
            label="Loading ..."
            label-class="text-input"
            label-style="font-size: 1.1em"
        />
    </q-page>
</template>
<script>

import TransferLimit from "../models/TransferLimit"
import TransferLimitCard from './TransferLimitCard.vue'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: "TransferLimits",
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['ramps']),
    },
    data() {
        return {
            separator: 'horizontal',
            filter: '',
            loading: false,
            serverPagination: {
                page: 1,
                sortBy: 'id',
                rowsPerPage: 16,
                descending: false,
                rowsNumber: 10 // specifying this determines pagination is server-side
            },
            showUserDialog: false,
            limits: [],
        }
    },
    methods: {
        ...mapActions(['set_ramps']),
        all() {
            this.loading = true
            TransferLimit.allByUser(this.user.id, (data) => {
                this.limits = data
                if(this.$auth.can('transfer-limits.set')) {
                    this.limits.push({ id: 0 })
                }
                this.loading = false
            }).catch(error => {
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.loading = false
            })
        },
        myTweak (offset) {
            return { minHeight: offset ? `calc(35vh - ${offset}px)` : '35vh' }
        },
        deleteTransferLimit(limit_id) {
            this.limits = this.limits.filter(record => record.id !== limit_id)
        },
        makeTransferLimit() {
            this.all()
        },
    },
    created() {
        if (! this.ramps.length) {
            this.loading = true
            this.set_ramps().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    mounted() {
        this.all()
    },
    watch: {},
    components: {
        TransferLimitCard
    },
}
</script>
<style>

</style>
